import { ScanLine, ShieldCheck, UserRound, ArrowDown, ArrowRight } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";

const NODES = [
  { id: "scanner", icon: ScanLine, title: "Scanner", body: "Scans the sticker and chooses a reason. Sees no personal details." },
  { id: "carlink", icon: ShieldCheck, title: "CARLINK", body: "Looks up the CARLINK ID and relays the message to the owner.", core: true },
  { id: "owner", icon: UserRound, title: "Vehicle owner", body: "Receives the alert. Their number stays private." },
];

const Connector = () => (
  <div className="flex items-center justify-center py-1 text-[#FF5500] md:px-1 md:py-0" aria-hidden="true">
    <ArrowDown className="h-5 w-5 md:hidden" />
    <ArrowRight className="hidden h-5 w-5 md:block" />
  </div>
);

const Node = ({ n }) => (
  <div data-testid={`privacy-node-${n.id}`} className={`flex-1 rounded-2xl border p-6 lg:p-8 ${n.core ? "border-[#FF5500]/40 bg-[#FF5500]/[0.06]" : "border-white/10 bg-[#0F111A]"}`}>
    <n.icon className={`h-6 w-6 ${n.core ? "text-[#FF5500]" : "text-slate-300"}`} aria-hidden="true" />
    <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-wider text-slate-50">{n.title}</h3>
    <p className="mt-2 text-sm leading-relaxed text-slate-400">{n.body}</p>
  </div>
);

export const PrivacySection = () => (
  <section className="section-pad border-t border-white/5 bg-[#0B0D14]">
    <div className="container-x">
      <SectionHeading
        label="Privacy by design"
        title="Your number stays private."
        body="The person scanning the QR does not receive the owner's personal phone number. CARLINK acts as the communication layer between the scanner and the vehicle owner."
      />
      <div data-testid="privacy-flow-diagram" role="img" aria-label="Scanner connects to CARLINK, which connects to the vehicle owner" className="mt-14 flex flex-col md:flex-row md:items-stretch">
        {NODES.map((n, i) => (
          <div key={n.id} className="contents">
            {i > 0 && <Connector />}
            <Node n={n} />
          </div>
        ))}
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <p className="rounded-xl border border-white/10 bg-[#0F111A] p-5 text-sm text-slate-400">
          <span className="label-mono block text-slate-500">What the QR contains</span>
          <span className="mt-2 block font-mono text-slate-200">carlink …/v/CL-8X92K7</span>
        </p>
        <p className="rounded-xl border border-white/10 bg-[#0F111A] p-5 text-sm text-slate-400">
          <span className="label-mono block text-slate-500">What the scanner sees</span>
          <span className="mt-2 block font-mono text-slate-200">Owner number: <span className="text-[#00E676]">hidden</span></span>
        </p>
      </div>
    </div>
  </section>
);
